/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionSubService } from '../../models/subscription-sub-service';

export interface GetSubscriptionSubService$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The object ID. Must be a valid ID.
 */
  serviceUid: string;
}

export function getSubscriptionSubService(http: HttpClient, rootUrl: string, params: GetSubscriptionSubService$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionSubService>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionSubService.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('serviceUid', params.serviceUid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubscriptionSubService>;
    })
  );
}

getSubscriptionSubService.PATH = '/subscriptions/{uid}/sub-service/{serviceUid}';
